<template>
  <v-card
      color="transparent"
      class="mx-auto pa-1"
      flat
  >
    <div v-if="images.length === 0" class="pa-3 text-center">
      <p>Este proveedor aún no ha cargado imágenes</p>
    </div>

    <carousel-3d v-else :autoplay="true" :autoplay-timeout="5000" :controls-visible="true">
      <slide v-for="(image, i) in images" :key="i" :index="i">
        <figure>
          <img :src="image.path" >
          <figcaption></figcaption>
        </figure>
      </slide>
    </carousel-3d>
  </v-card>

</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
  name: "GalleryCarousel",
  components: {
    Carousel3d,
    Slide
  },
  props:{
    images: {
      type: Array,
      required: true
    }
  }

}
</script>

<style scoped>

</style>
